// post pricing elements (subtotal, discount, recurring pricing, etc.)
const discountEl = document.querySelector('#productTissuesV2PurchaseDiscount');
const discountAmt = discountEl.querySelector('#productTissuesV2PurchaseDiscountInfoPrice');
const recurringEl = document.querySelector('#productTissuesV2Learn');
const subtotal = document.querySelector('#productTissuesV2PurchaseSubtotalPrice');


// circular check SVG; fill follows the element's text color so CSS owns the state
const checkSVG = `<svg class="checkIcon" width="27" height="23" viewBox="0 0 27 23" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M10.564 0.0547104C6.55781 0.422704 2.98055 2.84718 1.21414 6.39137C-0.142199 9.11287 -0.374077 12.2957 0.578651 15.1136C2.31592 20.2512 7.32694 23.4731 12.7562 22.9432C17.9338 22.438 22.1221 18.5649 23.0256 13.447C23.2114 12.3943 23.2111 10.6368 23.0248 9.57238C22.79 8.23041 21.9977 6.10249 21.7329 6.10249C21.6685 6.10249 21.3742 6.35168 21.079 6.65619L20.5423 7.2098L20.7881 7.81865C21.4097 9.35817 21.6547 11.4434 21.3993 13.0224C21.0514 15.1746 20.0471 17.0691 18.4476 18.5906C15.6793 21.2239 11.9256 22.0266 8.2383 20.7735C6.5156 20.1881 4.7307 18.8636 3.55553 17.2987C3.03228 16.6018 2.30649 15.1102 2.00214 14.1064C1.76615 13.3279 1.74972 13.1589 1.74972 11.5155C1.74972 9.86663 1.7655 9.70572 2.00429 8.92467C2.51614 7.25061 3.26164 5.95657 4.3905 4.78273C6.25524 2.84367 8.4599 1.83907 11.171 1.69315C13.2465 1.58146 15.3381 2.16709 17.1405 3.36471C17.4941 3.59964 17.7909 3.78081 17.8002 3.7674C17.8095 3.75398 18.0207 3.4565 18.2697 3.10645L18.7222 2.46994L18.419 2.22473C17.4699 1.45729 15.4602 0.570382 13.9845 0.267715C13.1482 0.0962567 11.3388 -0.0164454 10.564 0.0547104ZM26.2529 0.264384C24.0949 1.06523 21.7057 2.49372 19.5291 4.28446C17.2079 6.19419 14.1345 9.66297 12.4869 12.2326C12.2993 12.5252 12.1132 12.7647 12.0734 12.7647C12.0335 12.7647 11.562 12.2616 11.0256 11.6466C10.4892 11.0317 9.93046 10.3967 9.78394 10.2355C9.63741 10.0744 9.2013 9.57821 8.81496 9.13286C8.42853 8.68761 8.07693 8.32322 8.0335 8.32322C7.99008 8.32322 7.47897 8.66679 6.89764 9.0866C6.31631 9.50641 5.73722 9.91826 5.61087 10.0018L5.38105 10.1537L5.5752 10.3719C8.50071 13.6607 12.2855 17.8538 12.3283 17.8535C12.3595 17.8533 12.4652 17.6556 12.5631 17.414C12.9114 16.555 13.949 14.4761 14.6022 13.3285C16.3702 10.2227 18.1258 7.92331 20.5492 5.53935C22.4539 3.66561 24.6928 1.97814 26.4163 1.11714L27 0.825581V0.410582C27 0.18231 26.9894 -0.00247328 26.9767 2.50384e-05C26.9639 0.00243083 26.6381 0.121425 26.2529 0.264384Z" fill="currentColor"/>
</svg>`


/***************************************** Slidshow *****************************/

// slideshow
new Swiper("#productTissuesV2Swiper", {
    effect: "fade",
    loop: true,
    autoplay: {
        delay: 5000,
    },
    navigation: {
        nextEl: '#productTissuesV2SwiperRight',
        prevEl: '#productTissuesV2SwiperLeft',
    },
    on: {
        slideChange: function () {
            document.querySelector('#productTissuesV2SwiperIndex span').innerHTML = this.realIndex + 1;
        }
    }
})

/***************************************** FAQ Slider *****************************/

// setup reviews swipers for all faq items that contain it
let reviewSwipers = document.querySelectorAll('.productTissuesV2SliderReviews.swiper');
reviewSwipers.forEach(swiper => {
    new Swiper(swiper, {
        slidesPerView: 1.2,
        spaceBetween: 12,
        centeredSlides: true,
        breakpoints: {
            801: {
                spaceBetween: 20
            }
        }
    })
})

// needed FAQ variables
const FAQs = document.querySelectorAll('.productTissuesV2SliderContentItem');
// get the buttons
let nextBtn = document.querySelector(`#productTissuesV2Slider .productTissuesV2SliderNavigationNext`);
let prevBtn = document.querySelector(`#productTissuesV2Slider .productTissuesV2SliderNavigationPrev`);

// open slider on 'learn more' click
document.querySelector('#productTissuesV2FAQ').addEventListener('click', function () {
    let sliderFaqs = document.querySelectorAll('.productTissuesV2SliderContentItem');
    let foundActive = [...sliderFaqs].some(faq => faq.classList.contains('active'))
    // show the first element if there was no active one before
    !foundActive ? document.querySelector('.productTissuesV2SliderContentItem').classList.add('active') : '';

    // call the open slider function
    openSlider();
})

/*
// update nav buttons
function updateNavButtons() {
    // needed nav variables
    let isBeginning = false;
    let isEnding = false;
    let type = document.querySelector('.productTissuesV2SliderContentItem.active').dataset.id;
}
 */

// button click nav
nextBtn.onclick = () => {
    helperFunction(true)
};
prevBtn.onclick = () => {
    helperFunction(false)
};

// helper function for faqs slider nav
function helperFunction(goNext) {
    // needed variables
    let targetEl = "";
    let currentEl = document.querySelector('.productTissuesV2SliderContentItem.active');
    let currentIndex = "";
    let numEls = document.querySelectorAll('.productTissuesV2SliderContentItem');

    // get the current index
    numEls.forEach((el, index) => {
        if (el.classList.contains('active')) {
            currentIndex = index;
        }
    })

    // no element? exit
    if (!currentEl || numEls.length === 1) {
        return;
    }

    if (currentIndex === numEls.length - 1 && goNext === true) {
        // loop to start if at end
        targetEl = numEls[0];
    } else if (currentIndex === 0 && goNext === false) {
        // loop to end if at start
        targetEl = numEls[numEls.length - 1];
    } else {
        // determine if we need next or previous sibling
        targetEl = goNext === true ? currentEl.nextElementSibling : currentEl.previousElementSibling;
    }
    if (targetEl != null) {
        currentEl?.classList.remove('active');
        targetEl?.classList.add('active');

        // update the dropdown to match the active faq
        let dropdownItem = document.querySelector(`.productTissuesV2SliderDropdownContainerItem[data-id="${targetEl.dataset.id}"]`);
        if (dropdownItem) {
            document.querySelector('#productTissuesV2SliderDropdownButton span').innerHTML = document.querySelector(`.productTissuesV2SliderDropdownContainerItem[data-id="${targetEl.dataset.id}"]`)?.innerHTML;
            document.querySelectorAll('.productTissuesV2SliderDropdownContainerItem').forEach(element => {
                element.classList.remove("hidden");
                if (element.dataset.id === targetEl.dataset.id) {
                    element.classList.add("hidden");
                }
            });
        }
    }

    // scroll to top of slider content
    document.querySelector('#productTissuesV2SliderContent')?.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
}

// open faqs dropdown nav on click
document.querySelector('#productTissuesV2SliderDropdownButton').addEventListener('click', function () {
    this.classList.toggle('active');
})

// change faq on dropdown select
document.querySelectorAll('.productTissuesV2SliderDropdownContainerItem').forEach(item => {
    item.addEventListener('click', function () {
        // change active faq
        document.querySelectorAll('.productTissuesV2SliderContentItem').forEach(faq => faq.classList.remove('active'));
        document.querySelector(`.productTissuesV2SliderContentItem[data-id="${this.dataset.id}"]`).classList.add('active');

        // show any hidden items in the dropdown from previous selection
        document.querySelectorAll('.productTissuesV2SliderDropdownContainerItem').forEach(element => element.classList.remove('hidden'));

        // hide the item in the dropdown that is currently selected
        this.classList.add('hidden')

        // change dropdown label
        document.querySelector('#productTissuesV2SliderDropdownButton span').innerHTML = this.innerHTML;

        // close dropdown
        document.querySelector('#productTissuesV2SliderDropdownButton').classList.remove('active');

        // scroll to top of slider content
        document.querySelector('#productTissuesV2SliderContent')?.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    })
});

// close slider on click
document.querySelector('#productTissuesV2SliderClose').addEventListener('click', function () {
    closeSlider();
})

/***************************************** End FAQ Slider *****************************/

/***************************************** Slider Popup *****************************/

const slider = document.querySelector("#productTissuesV2Slider");

function openSlider() {
    // open slider modal
    slider.showModal();

    // update the dropdown to match the active faq
    let activeFAQ = document.querySelector('.productTissuesV2SliderContentItem.active').dataset.id;
    document.querySelectorAll('.productTissuesV2SliderDropdownContainerItem').forEach(element => {
        element.classList.remove("hidden");
        if (element.dataset.id === activeFAQ) {
            element.classList.add("hidden");
            document.querySelector('#productTissuesV2SliderDropdownButton span').innerHTML = element.innerHTML;
        }
    });

    // no scroll on body
    document.querySelector('body').classList.add('noScroll');
}

function closeSlider() {
    // close modal
    slider.close();

    // close dropdown if open
    document.querySelector('#productTissuesV2SliderDropdownButton').classList.remove('active');

    // remove no scroll
    document.querySelector('body').classList.remove('noScroll');
}

let dropdown = document.querySelector('#productTissuesV2SliderDropdown');
// modal close and/or dropdown close on outside click
slider.addEventListener('click', function (e) {
    if (e.target === this) {
        closeSlider();
    }
    if (!dropdown.contains(e.target)) {
        dropdown.querySelector('button').classList.contains('active') ? dropdown.querySelector('button').classList.remove('active') : "";
    }
})

// accessibility close
slider.addEventListener('close', function () {
    closeSlider();
})

// function for generating stars
function stars(rating) {
    let HTML = "";

    // add full stars
    for (let i = 0; i < Math.floor(rating); i++) {
        HTML += `<svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.13868 0L11.0948 6.02046L17.4251 6.02046L12.3038 9.74131L14.26 15.7618L9.13868 12.0409L4.01737 15.7618L5.97353 9.74131L0.852221 6.02046L7.18251 6.02046L9.13868 0Z" fill="#1758FF"/>
</svg>
`;
    }

    // add empty stars
    for (let i = 0; i < 5 - Math.ceil(rating); i++) {
        HTML += `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="2.79 3.4 18.42 17.67"><path d="M6.50929 19.3369C6.45781 19.637 6.58119 19.9404 6.82754 20.1193C7.0739 20.2983 7.40051 20.3219 7.67004 20.1802L12.0001 17.9038L16.3302 20.1802C16.5998 20.3219 16.9264 20.2983 17.1727 20.1193C17.4191 19.9404 17.5425 19.637 17.491 19.3369L16.664 14.5154L20.1671 11.1007C20.3852 10.8882 20.4637 10.5703 20.3696 10.2807C20.2755 9.99104 20.0251 9.77997 19.7237 9.73618L14.8826 9.03272L12.7175 4.64594C12.5828 4.37288 12.3046 4.2 12.0001 4.2C11.6956 4.2 11.4175 4.37288 11.2827 4.64594L9.1177 9.03272L4.27652 9.73618C3.97517 9.77997 3.72481 9.99104 3.63071 10.2807C3.53661 10.5703 3.61509 10.8882 3.83315 11.1007L7.33626 14.5154L6.50929 19.3369Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"></path></svg>`;
    }

    return HTML;
}

// append reviews for slider
async function sliderReviews(page) {
    let response = await fetch(`https://api-cdn.yotpo.com/v1/widget/D9LZolxeDIeQPdn40QfzQVtXIZvRFPJxqhQThc1b/products/3590230671444/reviews?per_page=100&page=${page}`)
        .then(response => response.json());
    let yotpo = response.response;

    // create array to append softness reviews to
    let softnessReviews = [];

    // counter for number of reviews found
    let numReviews = 0;


    // if no reviews, leave
    if (yotpo.reviews.length === 0) {
        return;
    }

    // get the reviews that mention "softness" within the first 110 reviews

    for (let i = 0; i < yotpo.reviews.length; i++) {
        if ((yotpo.reviews[i].content.toLowerCase().includes("softness") || yotpo.reviews[i].content.toLowerCase().includes("soft")) && numReviews < 10) {
            numReviews = i + 1;
            softnessReviews.push(yotpo.reviews[i]);
        }
    }

    // reset containers
    document.querySelector("#productTissuesV2Slider #productTissuesV2SliderReviewsInner").innerHTML = "";

    // append in range
    for (let i = 0; i < softnessReviews.length; i++) {
        document.querySelector("#productTissuesV2Slider #productTissuesV2SliderReviewsInner").insertAdjacentHTML("beforeend", `
            <div class="productTissuesV2SliderReviewsItem">
                <div class="productTissuesV2SliderReviewsItemTop">
                    <div class="productTissuesV2SliderReviewsItemCustomer">
                        <span class="productTissuesV2SliderReviewsItemCustomerInitial">
                            ${softnessReviews[i].user.display_name.substring(0, 1).toUpperCase()}
                        </span>
                        <div class="productTissuesV2SliderReviewsItemCustomerName">
                           ${softnessReviews[i].user.display_name}
                            <span>Verified Buyer</span>
                        </div>
                    </div>
                    <div class="productTissuesV2SliderReviewsItemStars">
                       ${stars(softnessReviews[i].score)}
                    </div>
                </div>
                <div class="productTissuesV2SliderReviewsItemBottom">
                    <div class="productTissuesV2SliderReviewsItemTitle">
                        ${softnessReviews[i].title}
                    </div>
                    <div class="productTissuesV2SliderReviewsItemReview">
                        ${softnessReviews[i].content}
                    </div>
                </div>
            </div>
            `);
    }
}

// sliderReviews(1);

// show hide the buy now button
window.addEventListener('scroll', function () {
    if (document.querySelector("#productTissuesV2ATC").getBoundingClientRect().top < 0) {
        document.querySelector('#buyNow').classList.add('active');
    } else {
        document.querySelector('#buyNow').classList.remove('active');
    }
});

// listen for buy now click, and scroll to the top of the page smoothly
document.querySelector('#buyNow').addEventListener('click', function (e) {
    e.preventDefault();

    // scroll to top on desktop, otherwise scroll to title
    if (window.innerWidth > 800) {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    } else {
        // scroll to the title which is essential the height of the productSwiper
        window.scrollTo({
            top: document.querySelector("#productTissuesV2Swiper").clientHeight - 60,
            behavior: 'smooth'
        });
    }
});

/***************************************** Subscribe /Buy Once *****************************/

// subscribe or buy once change event
document.querySelectorAll(".productTissuesV2FormRadioInput").forEach(function (element) {
    element.addEventListener("change", function () {
        // check this
        element.checked = true;

        // remove active class from all
        document.querySelectorAll(".productTissuesV2FormRow").forEach(function (el) {
            el.classList.remove("active");
        })

        // add active class to parent
        element.closest(".productTissuesV2FormRow").classList.add("active");

        // keep the discount rows in step with the new purchase option
        refreshDiscount();
    });
})

/***************************************** Frequency *****************************/

// frequency close
document.querySelector("body").addEventListener("click", function (e) {
    let activeSelect = document.querySelector(".productTissuesV2FormFrequencySelectLabel.active");
    if (activeSelect && !e.target.closest(".productTissuesV2FormFrequencySelectLabel.active")) {
        activeSelect.classList.remove("active");

        // re-add current frequency to dropdown
        document.querySelectorAll('.productTissuesV2FormFrequencySelectOption').forEach(function (element) {
            if (!element.classList.contains("active")) {
                element.classList.add("active");
            }
        })
    }
});

// frequency open
document.querySelector(".productTissuesV2FormFrequencySelectLabel").addEventListener("click", function (e) {
    e.preventDefault();
    if (this.classList.contains("active")) {
        this.classList.remove("active");
        return;
    }

    // remove current frequency from dropdown
    document.querySelectorAll('.productTissuesV2FormFrequencySelectOption').forEach(function (element) {
        let currentSellingPlan = document.querySelector('.productTissuesV2FormFrequency').getAttribute('selling_plan');
        if (parseInt(element.getAttribute('selling_plan')) === parseInt(currentSellingPlan)) {
            element.classList.remove("active");
        }
    })

    // open dropdown
    this.classList.add("active");
});

// frequency change
document.querySelectorAll(".productTissuesV2FormFrequencySelectOption").forEach(function (element) {
    element.addEventListener("click", function () {
        this.closest(".productTissuesV2FormFrequency").setAttribute("selling_plan", this.getAttribute("selling_plan"))
        this.parentElement.parentElement.querySelector(".productTissuesV2FormFrequencySelectLabel").innerHTML = this.innerHTML;
        updateSavings(this.querySelector("span").innerHTML);
    });
})

// frequency setup
// popular is the default
document.querySelectorAll(".productTissuesV2FormFrequencySelectOption span.popular").forEach(function (element) {
    element.click();
})

// update the savings per year for the subscription option based on the selected frequency
function updateSavings(cadence) {
    // get the cadence
    let cad = parseInt(cadence.match(/\d+/g)[0]);

    // get the price element
    let tissuesPricing = document.querySelector('.productTissuesV2FormPrice');

    // get the active form's price and compare price for subscription
    let price = tissuesPricing.dataset.subPrice;
    let comparePrice = tissuesPricing.dataset.price;

    // determine the difference in price between subscription and one time purchase
    let difference = (comparePrice - price) / 100;

    // determine how many times per year full deliveries can be made based on cadence
    let yearlyDeliveries = Math.floor((52 / cad));

    if (comparePrice) {
        // calculate savings per year and update the DOM
        let savings = difference * yearlyDeliveries;

        document.querySelector('.productTissuesV2FormRowBenefitsSavings span').innerHTML = `Save $${savings} per year`;
    }
}

/**************************************** Refresh Discount *************************************/

// keep the welcome discount rows in step with the selected purchase option
function refreshDiscount() {
    const activeForm = document.querySelector('.productTissuesV2Form');
    if (activeForm === null) {
        return;
    }

    // check if the current active form is set to the subscribe option
    const isSub = !!activeForm.querySelector('.productTissuesV2FormRadioInput[value="Subscribe"]:checked');
    const pricing = Number(activeForm.querySelector('.productTissuesV2FormPrice').dataset[isSub ? 'subPrice' : 'price']);

    // get the discount headline elements
    const discountHeadlines = document.querySelectorAll('.productTissuesV2FormDiscount');

    const firstOrderEl = activeForm.querySelector('.productTissuesV2FormRowFirst');

    // the money off only lands on a first subscription order, and only when the discount_code cookie
    // handed us a code from the matrix. no code means every line below has no percent to quote
    const showDiscount = welcomeDiscountApplies(isSub);

    // the subscription price drives the first order line and the recurring copy either way, so read
    // it whichever option is selected
    const subPricing = Number(activeForm.querySelector('.productTissuesV2FormPrice').dataset.subPrice);

    // first order is discounted, renewals are not, so these two prices are no longer the same number
    let firstOrderPrice = pricing;
    if (showDiscount) {
        // calculate the total discount value
        const discountValue = Math.round(pricing * (welcomeDiscount.percent / 100));
        firstOrderPrice = pricing - discountValue;

        // pdp figure is an estimate from the code matrix; the drawer shows shopify's real number
        discountEl.querySelector("#productTissuesV2PurchaseDiscountInfoCodeLabel").innerHTML = `${checkSVG} ${welcomeDiscount.code} ${welcomeDiscount.percent}% off`;

        // update the total amount taken off the first subscription order
        discountAmt.textContent = `-${price(discountValue)}`;
    }

    // update the price of the first subscription order with the discount
    subtotal.innerHTML = price(firstOrderPrice);

    // the first order line sits on the subscription row and always quotes the discounted sub price,
    // whichever option is selected, so it needs a valid code rather than a sub selection. left empty
    // and hidden without one, since a bare "First order" reads as a broken price
    let firstOrderHTML = "";
    if (hasWelcomeCode) {
        const subDiscount = Math.round(subPricing * (welcomeDiscount.percent / 100));
        firstOrderHTML = `First order ${price(subPricing - subDiscount)}`;
    }

    firstOrderEl.innerHTML = firstOrderHTML;
    firstOrderEl.classList.toggle("active", hasWelcomeCode);

    // showcase the recurring price
    recurringEl.querySelector('.recurring').innerHTML = price(subPricing);

    // both headline variants name the percent, so with no code there is nothing to say
    let headlineHTML = "";
    if (hasWelcomeCode) {
        headlineHTML = `${checkSVG} Subscribe and get an additional ${welcomeDiscount.percent}% off`;

        // the code already pays out on the selected option, so name it rather than upselling
        if (showDiscount) {
            headlineHTML = `${checkSVG}<span>${welcomeDiscount.code} ${welcomeDiscount.percent}%</span> off auto-applied`;
        }
    }

    // update the welcome headlines content and toggle their respective classes
    discountHeadlines.forEach(headline => {
        headline.innerHTML = headlineHTML;
        headline.classList.toggle("active", hasWelcomeCode);
        headline.classList.toggle("activeDiscount", showDiscount);
    });

    // show the money off elements only when there is money off, and the recurring copy whenever the
    // subscription is selected
    [subtotal, discountEl].forEach(el => el?.classList.toggle("active", showDiscount));
    recurringEl?.classList.toggle("active", isSub);
}

// hold the first paint until the welcome code lookup settles, otherwise the discount rows render
// against hasWelcomeCode's default of false. every later call comes from a user action, by which
// point the promise has already resolved
(async () => {
    await welcomeCodeReady;
    refreshDiscount();
})();

// listen for custom event dispatch from theme-welcome-discount.js
// this ensures the content accurately updates right away when the discount has been altered
document.addEventListener("welcomeDiscountChange", refreshDiscount);

document.querySelector("#productTissuesV2ATC").addEventListener("click", async function (e) {
    e.preventDefault();

    // collect formdata
    let formData = {
        id: parseInt(document.querySelector(".productTissuesV2Form.active").getAttribute("variant")),
        quantity: 1,
        properties: {
            "_added_at": Date.now() // When the line entered the cart, keeps the mini cart order stable
        }
    };

    // Subscription
    if (document.querySelector(`.productTissuesV2FormRadioInput[value="Subscribe"]:checked`)) {
        formData.selling_plan = parseInt(document.querySelector(".productTissuesV2Form.active .productTissuesV2FormFrequency").getAttribute("selling_plan"))
    }

    this.classList.add("loading");

    // // clear cart
    // await fetch("/cart/clear.js");

    // add to cart
    await addProduct(formData);

    // open cart
    await openCart(false);

    // stop loading
    this.classList.remove("loading");
});

/*********************************** Stars *************/

document.querySelector("#productTissuesV2Stars").addEventListener("click", function () {
    // show reviews modal
    document.querySelector('#reviewsWidget').showModal();
    // no scroll
    document.body.classList.add("noScroll");
});

/***************************************** Notify Me *****************************/

document.querySelector("#productTissuesV2NotifyForm").addEventListener("submit", async function (e) {
    e.preventDefault();

    // submit to klaviyo
    sendKlaviyoBackInStockRequest(document.querySelector("#productTissuesV2NotifyFormEmail").value, 47062264119578);

    // reset form
    this.reset();

    // show success message
    document.querySelector("#productTissuesV2NotifyForm").classList.remove("active");
    document.querySelector("#productTissuesV2NotifySuccess").classList.add("active");
});